import React, { useEffect, useState } from 'react';
import SalesDataOrder from 'mage-swagfaces/sales/SalesDataOrder';
import { AULink } from 'components/AULink';
import { ORDER_HISTORY, CREATE_ORDER_TICKET } from 'constants/navigation';
import { getCustomerOrders } from 'services/magenum/order';
import { ActionLabel, HeaderWrapper } from './styled';
import { OrdersList } from 'components/Orders/OrdersList';
import { StyledH3 } from 'components';

export const RecentOrders = (): JSX.Element => {
  const [recentOrders, setRecentOrders] = useState<SalesDataOrder[]>([]);

  useEffect(() => {
    const getRecentOrders = async () => {
      const result = await getCustomerOrders(1, 2);
      if (result.isRight()) {
        setRecentOrders(result.value.items);
      }
    };
    getRecentOrders();
  }, []);

  return (
    <>
      <HeaderWrapper>
        <StyledH3 secondary>Recent Orders</StyledH3>
        <ActionLabel>
          <AULink path={ORDER_HISTORY.url} id="view-all-orders">
            View All
          </AULink>
        </ActionLabel>
        <ActionLabel>
          <AULink path={CREATE_ORDER_TICKET.url} id="open-ticket">
            Open Ticket
          </AULink>
        </ActionLabel>
      </HeaderWrapper>
      <OrdersList orders={recentOrders} />
    </>
  );
};
